<div class="card">
  <div class="card-header">
    <h4 class="card-title float-left" id="basic-layout-form">{{ title }}</h4>
    <div class="clear-float-left"></div>
    <br>
    <button class="btn btn-raised btn-primary float-right" (click)="openExportModal()"><i
      class="ft-file-text font-medium-3"></i> {{ 'buttons.exportText' | translate }}
    </button>

    <app-company-selection-list [ngClass]="companySelectionListClass" [active]="companySelectionListActive"
                                [hideLabel]="true"
                                [selectCompanyText]="'financialTransactions.selectCompanyPlaceHolder' | translate"
                                (companyChangedEvent)="handleCompanyChanged($event)"></app-company-selection-list>

    <app-user-selection-list class="d-none d-xl-block selection-list" [hideLabel]="true"
                             [selectObjectText]="'financialTransactions.selectUserPlaceHolder' | translate"
                             [(companyId)]="financialTransactionFilter.CompanyId"
                             (selectedObjectChangedEvent)="handleUserChanged($event)"></app-user-selection-list>

    <app-module-selection-list class="d-none d-xl-block selection-list" [hideLabel]="true"
                               [selectModuleText]="'financialTransactions.selectModulePlaceHolder' | translate"
                               (moduleChangedEvent)="handleModuleChanged($event)"></app-module-selection-list>

    <app-boolean-toggle-filter class="d-none d-xl-block filter-input"
                               [booleanToggleFilterText]="'financialTransactions.showUpgradeCreditText' | translate"
                               (booleanToggleFilterChangedEvent)="handleBooleanToggleFilterChanged($event)"></app-boolean-toggle-filter>

    <div class="clear-float-left"></div>
    <h5
      *ngIf="companyId || companyName">{{ 'financialTransactions.companyCreditAmountText' | translate }} {{ companyCreditAmount }}</h5>
  </div>
  <div class="card-body">
    <div [class]="hasDesktopView ? 'px-3' : 'px-0'">
      <table
        [class]="hasDesktopView ? 'table table-sortable table-responsive-md' : 'table-borderless table-sortable table-responsive-sm table'">
        <thead>
        <tr>
          <th *ngFor="let field of fieldCollection"
              [ngClass]="getTableHeaderClass(field.canSort, pageConfiguration.IsAscending, field.displayClass)"
              (click)="sort(field.canSort, field.name)">{{ field.displayName | translate }}
          </th>
          <th>{{ 'financialTransactions.actionsFieldTitle' | translate }}</th>
        </tr>
        </thead>
        <tbody>
        <tr
          *ngFor="let financialTransaction of collection | paginate: { id: 'server', itemsPerPage: pageConfiguration.PageSize, currentPage: pageConfiguration.PageNumber, totalItems: pageConfiguration.TotalRecords }">
          <td class="d-none d-lg-table-cell">{{ financialTransaction.FinancialTransactionId }}</td>
          <td class="d-none d-sm-table-cell">{{ financialTransaction.CreatedAt | date:'d-M-y HH:mm:ss' }}</td>
          <td class="d-none d-sm-table-cell">{{ financialTransaction.Company.Name }}</td>
          <td class="d-none d-lg-table-cell">{{ financialTransaction.User.FullName }}</td>
          <td class="col-sm-2 col-2" *ngIf="financialTransaction.Module">{{ financialTransaction.Module.Name }}</td>
          <td *ngIf="!financialTransaction.Module">-</td>
          <td>{{ financialTransaction.AmountCurrency }}</td>
          <td class="d-none d-lg-table-cell">{{ financialTransaction.CreditAmountAfterCurrency }}</td>
          <td>
            <a *ngIf="sectionPermission.CanView" class="succes" data-original-title=""
               title="Details of financial transaction {{financialTransaction.FinancialTransactionId}}"
               (click)="openCustomModal('FinancialTransactionDetailsComponent', financialTransaction)">
              <i class="ft-info font-medium-3 ml-1"></i>
            </a>
          </td>
        </tr>
        </tbody>
      </table>
      <pagination-controls *ngIf="pageConfiguration.TotalRecords > pageConfiguration.PageSize"
                           (pageChange)="pageChanged($event)" id="server"
                           previousLabel="{{'pagination.previousLabel' | translate}}"
                           nextLabel="{{'pagination.nextLabel' | translate}}">
      </pagination-controls>
    </div>
  </div>
  <div class="form-actions">
    <button [hidden]="!companyId" class="btn btn-secondary btn-raised ml-3" type="button" (click)="close()">
      <i class="ft-x-square"></i> {{ 'buttons.closeText' | translate }}
    </button>
  </div>
</div>
